import AxiosInstance from "services/api";

export const ForeignCurrencyGoldCashCountReportService = {
  async getPaginate(query) {
    return await AxiosInstance.get("/private/foreign-currency-gold-cash-count-report", { params: query });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/foreign-currency-gold-cash-count-report/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post("/private/foreign-currency-gold-cash-count-report", payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/foreign-currency-gold-cash-count-report/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/foreign-currency-gold-cash-count-report/${id}`);
  },
};
